import { render, staticRenderFns } from "./dropdown_number_widget.vue?vue&type=template&id=ff3c190a&scoped=true"
import script from "./dropdown_number_widget.vue?vue&type=script&lang=js"
export * from "./dropdown_number_widget.vue?vue&type=script&lang=js"
import style0 from "./dropdown_number_widget.vue?vue&type=style&index=0&id=ff3c190a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3c190a",
  null
  
)

export default component.exports